export interface IError {
    offlineError?: IOfflineErrorPayload;
}

export interface IOfflineErrorPayload {
    message: string;
    tags: string[];
    userAgent: string;
    serviceWorkerEnabled?: boolean;
    serviceWorkerCompatible?: boolean;
    applicationCacheStatus?: any;
    extraDetails?: {[key: string]: any};
}

export enum ErrorActionTypes {
    SET_OFFLINE_ERROR = "SET_OFFLINE_ERROR",
    CLEAR_OFFLINE_ERROR = "CLEAR_OFFLINE_ERROR"
}
